<template>
  <v-container class="screen2">
    <v-layout row wrap>
      <gallery :images="images" :index="index" @close="index = null"></gallery>
      <v-flex xs4
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
      >
        <v-img class="gallery-img"
          aspect-ratio="1.33"
          @click="index = imageIndex"
          :style="{backgroundImage: 'url(' + image + ')'}">
        </v-img>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import VueGallery from 'vue-gallery'

  export default {
    data: function () {
      return {
        images: [
          // '/static/img/gallery/sadko/1.jpg',
          // '/static/img/gallery/sadko/2.jpg',
          // '/static/img/gallery/sadko/3.jpg',
          // '/static/img/gallery/sadko/4.jpg',
          // '/static/img/gallery/sadko/5.jpg',
          // '/static/img/gallery/sadko/6.jpg',
          // '/static/img/gallery/sadko/7.jpg',
          // '/static/img/gallery/sadko/8.jpg',
          // '/static/img/gallery/sadko/9.jpg'
          '/static/img/gallery/sadko/2-1.jpeg',
          '/static/img/gallery/sadko/2-2.jpeg',
          '/static/img/gallery/sadko/2-3.jpeg',
          '/static/img/gallery/sadko/2-4.jpeg',
          '/static/img/gallery/sadko/2-5.jpeg',
          '/static/img/gallery/sadko/2-6.jpeg',
          '/static/img/gallery/sadko/2-7.jpeg',
          '/static/img/gallery/sadko/2-8.jpeg',
          '/static/img/gallery/sadko/2-9.jpeg',
          '/static/img/gallery/sadko/2-10.jpeg',
          '/static/img/gallery/sadko/2-11.jpeg',
          '/static/img/gallery/sadko/2-12.jpeg',
          '/static/img/gallery/sadko/2-13.jpeg',
          '/static/img/gallery/sadko/2-14.jpeg',
          '/static/img/gallery/sadko/2-15.jpeg',
          '/static/img/gallery/sadko/2-16.jpeg',
          '/static/img/gallery/sadko/2-17.jpeg'
        ],
        index: null
      }
    },
    components: {
      'gallery': VueGallery
    }
  }
</script>

<style scoped>
.gallery-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.gallery-img:hover {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/screens/sadko/Gallery.vue